export default __webpack_public_path__ + "static/media/ic_on_demand.802f8da0.png";